export const en = {
  // Navigation
  home: "Home",
  calendar: "Calendar",
  lists: "Lists",
  profile: "Profile",
  
  // App Name
  appName: "mohammed family",
  
  // Home Page
  welcomeFamily: "Welcome Mohammed Family",
  familyCalendar: "Family Calendar",
  sharedLists: "Shared Lists",
  messaging: "Messaging",
  mediaLibrary: "Media Library",
  
  // Calendar
  addEvent: "Add Event",
  upcomingEvents: "Upcoming Events",
  today: "Today",
  
  // Lists
  shoppingList: "Shopping List",
  houseTasks: "House Tasks",
  addItem: "Add Item",
  completed: "Completed",
  
  // Profile
  editProfile: "Edit Profile",
  notifications: "Notifications",
  logout: "Logout",
  
  // Common
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  save: "Save",
  cancel: "Cancel",
  done: "Done"
};

export default en;